import { Service, ResultSetHeader, ServiceString } from './../../models';
import http, { HttpSuccessOrErrorType } from '../http';

export default {
    /**
     * 新增服务
     * @param params 参数
     */
    async create_service(params: Service & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params;
        return await http.post(`/restaurant/${string_id}/service`, {
            ...rest
        })
    },

    /**
     * 动态国际化
     * @param params 参数
     */
    async service_strings(params: { string_id: string, request: ServiceString[] }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, request } = params;
        return await http.post(`/restaurant/${string_id}/service/service_strings`, request)
    },

    /**
     * 获取服务列表
     * @param params 参数
     */
    async get_services(params: { string_id: string }): Promise<HttpSuccessOrErrorType<Service[]>> {
        const { string_id } = params;
        return await http.get(`/restaurant/${string_id}/services`)
    },

    /**
     * 根据id获取服务
     * @param params 参数
     */
    async get_service_id(params: { string_id: string, id: string }): Promise<HttpSuccessOrErrorType<Service>> {
        const { string_id, id } = params;
        return await http.get(`/restaurant/${string_id}/service/${id}`)
    },

    /**
     * 根据服务名称模糊查询服务列表
     * @param params 参数
     */
    async get_service_name(params: { string_id: string, name: string }): Promise<HttpSuccessOrErrorType<Service[]>> {
        const { string_id, name } = params;
        return await http.get(`/restaurant/${string_id}/service/`, {
            params: {
                name
            }
        })
    },

    /**
     * 编辑服务
     * @param params 参数
     */
    async patch_service(params: Service & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, id, ...rest } = params;
        return await http.patch(`/restaurant/${string_id}/service/${id}`, {
            ...rest
        })
    },

    /**
     * 删除服务
     * @param params 参数
     */
    async delete_service(params: { string_id: string, id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, id } = params;
        return await http.delete(`/restaurant/${string_id}/service/${id}`)
    },

    /**
     * 批量删除服务
     * @param params 参数
     */
    async delete_services(params: { string_id: string, ids: Array<number> }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ids } = params;
        return await http.delete(`/restaurant/${string_id}/services`, {
            data: {
                ids
            }
        })
    }

}